import React, { useState, useEffect } from "react";
import { notification, Card } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { SentinelService } from "../../services/SentinelService";
import { Sentinel } from "../../model_gen/sentinel";
import { useNavigate, useParams } from "react-router-dom";
import { usePermissions } from "../../PermissionsProvider";
import EditSentinelForm from "./EditSentinelForm";

const EditSentinel: React.FC = () => {
  const navigate = useNavigate();
  const { apiKey } = usePermissions();
  const { sentinelId } = useParams();
  const [loading, setLoading] = useState(false);
  const [sentinel, setSentinel] = useState<Sentinel | undefined>();
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (sentinelId) {
      setLoading(true);
      SentinelService.getSentinel(
        Number(sentinelId),
        setLoading,
        apiKey
      ).subscribe(
        (sentinel: Sentinel) => {
          setSentinel(sentinel);
          setLoading(false);
          setIsDataLoaded(true);
        },
        (error: any) => {
          console.error(error);
          notification.error({
            message: "Error",
            description: "Failed to fetch sentinel",
          });
          setLoading(false);
        }
      );
    }
  }, [sentinelId, apiKey]);

  const handleSubmit = (formData: Sentinel) => {
    setLoading(true);
    SentinelService.updateSentinel(
      formData,
      setLoading,
      apiKey
    ).subscribe(
      () => {
        notification.success({
          message: "Success",
          description: "Sentinel updated successfully",
        });
        navigate(-1);
      },
      (error: any) => {
        console.error(error);
        notification.error({
          message: "Error",
          description: "Failed to update sentinel",
        });
        setLoading(false);
      }
    );
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto" }}>
      <Card
        title="Edit Sentinel"
        extra={<CloseOutlined onClick={handleClose} style={{ cursor: "pointer" }} />}
        style={{ width: "100%" }}
      >
        <EditSentinelForm
          sentinel={sentinel}
          loading={loading}
          setLoading={setLoading}
          isDataLoaded={isDataLoaded}
          onSubmit={handleSubmit}
          onClose={handleClose}
          regenerationEnabled={true}
        />
      </Card>
    </div>
  );
};

export default EditSentinel;
